module.exports = __webpack_public_path__ + "static/media/detail-icon.6ed56591.svg";